var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ChangePasswordBase" }, [
    _c("section", [
      _c(
        "div",
        { staticClass: "steps_content" },
        [
          _c(
            "el-steps",
            { attrs: { active: _vm.active } },
            [
              _c("el-step", {
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function() {
                      return [
                        _c("div", [_vm._v("1")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.isBind ? "绑定" : "验证") + "手机号"
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-step", {
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function() {
                      return [
                        _c("div", [_vm._v("2")]),
                        _vm._v(" "),
                        _c("span", [_vm._v("设置新密码")])
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-step", {
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function() {
                      return [
                        _c("div", [_vm._v("3")]),
                        _vm._v(" "),
                        _c("span", [_vm._v("完成更改")])
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form_content" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-suffix": "：",
                "label-width": "120px",
                size: "medium"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === 0,
                      expression: "active === 0"
                    }
                  ]
                },
                [
                  !_vm.isBind
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "手机号", prop: "mobileTm" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "440px" },
                            attrs: {
                              maxlength: 11,
                              autocomplete: "off",
                              placeholder: "请输入手机号码",
                              readonly: ""
                            },
                            model: {
                              value: _vm.form.mobileTm,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mobileTm", $$v)
                              },
                              expression: "form.mobileTm"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { attrs: { label: "手机号", prop: "mobile" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "440px" },
                            attrs: {
                              maxlength: 11,
                              autocomplete: "off",
                              placeholder: "请输入手机号码"
                            },
                            model: {
                              value: _vm.form.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mobile", $$v)
                              },
                              expression: "form.mobile"
                            }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "验证码", prop: "code" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "302px" },
                        attrs: {
                          maxlength: 6,
                          autocomplete: "off",
                          placeholder: "请输入短信验证码"
                        },
                        model: {
                          value: _vm.form.code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "135px" },
                          attrs: {
                            disabled: _vm.timer.countDown < 60,
                            loading: _vm.loading,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.performVerify()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.timer.countDownText) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === 1,
                      expression: "active === 1"
                    }
                  ]
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "no_margin_bottom",
                      attrs: {
                        "show-message": false,
                        label: "密码",
                        prop: "password"
                      }
                    },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "440px" },
                          attrs: {
                            maxLength: 16,
                            type: _vm.form.showPassword ? "text" : "password",
                            autocomplete: "new-password",
                            placeholder:
                              "请输入8-16位包含大小写字母，特殊字符和数字的密码"
                          },
                          model: {
                            value: _vm.form.password,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "password",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.password"
                          }
                        },
                        [
                          _c("i", {
                            class: [
                              "el-input__icon",
                              _vm.form.showPassword
                                ? "ri-eye-fill"
                                : "ri-eye-off-fill"
                            ],
                            attrs: { slot: "suffix" },
                            on: {
                              click: function($event) {
                                _vm.form.showPassword = !_vm.form.showPassword
                              }
                            },
                            slot: "suffix"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form_password_verifiers" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.PasswordLengthRge.test(
                                  _vm.form.password
                                )
                                  ? "success"
                                  : "info",
                                hit: ""
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-success" }),
                              _vm._v("8-16位之间\n              ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.UppercaseLowercaseReg.test(
                                  _vm.form.password
                                )
                                  ? "success"
                                  : "info",
                                hit: ""
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-success" }),
                              _vm._v("含大小写字母\n              ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.NumberReg.test(_vm.form.password)
                                  ? "success"
                                  : "info",
                                hit: ""
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-success" }),
                              _vm._v("含数字\n              ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.SpecialCharactersReg.test(
                                  _vm.form.password
                                )
                                  ? "success"
                                  : "info",
                                hit: ""
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-success" }),
                              _vm._v("含特殊字符，如:@#*\n              ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "确认密码", prop: "againPassword" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "440px" },
                          attrs: {
                            type: _vm.form.showAgainPassword
                              ? "text"
                              : "password",
                            autocomplete: "new-password",
                            placeholder: "请再一次输入密码"
                          },
                          model: {
                            value: _vm.form.againPassword,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "againPassword", $$v)
                            },
                            expression: "form.againPassword"
                          }
                        },
                        [
                          _c("i", {
                            class: [
                              "el-input__icon",
                              _vm.form.showAgainPassword
                                ? "ri-eye-fill"
                                : "ri-eye-off-fill"
                            ],
                            attrs: { slot: "suffix" },
                            on: {
                              click: function($event) {
                                _vm.form.showAgainPassword = !_vm.form
                                  .showAgainPassword
                              }
                            },
                            slot: "suffix"
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === 2,
                      expression: "active === 2"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "set_success" }, [
                    _c("img", {
                      attrs: {
                        alt: "",
                        src: require("../../assets/img-4/success-ico.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("密码更改成功，点击【完成】重新登录")])
                  ])
                ]
              )
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "footer",
      { attrs: { slot: "footer" }, slot: "footer" },
      [
        _vm.active === 2
          ? [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.nextStep()
                    }
                  }
                },
                [_vm._v("完成")]
              )
            ]
          : [
              _vm.active !== 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.previousStep()
                        }
                      }
                    },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.active === 2,
                    loading: _vm.nextLoading,
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.nextStep()
                    }
                  }
                },
                [_vm._v("下一步\n      ")]
              )
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "verify_box" },
      [
        _vm.verifyShow
          ? _c("Verify", {
              ref: "verifyRef",
              attrs: {
                captchaType: "blockPuzzle",
                imgSize: { width: "240px", height: "120px" },
                mode: "pop"
              },
              on: { close: _vm.verifyClose, success: _vm.verifySuccess }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7acd30cf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7acd30cf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword/indexBase.vue
// module id = null
// module chunks = 